import * as React from "react";
import { GeneralModal } from "../Common/GeneralModal/GeneralModal";
import { ScaVerify } from "../ScaAirwallex/ScaVerify";

export function ScaVerifyModal({
  open = true,
  setOpen,
  scaSessionCode,
  onReady,
  onVerificationSucceed,
  onVerificationFailed,
  onError,
  onCancel,
  className = "sca-verify-modal-wrapper",
}) {
  return (
    <GeneralModal
      open={open}
      setOpen={setOpen}
      className={className}
    >
      <ScaVerify
        scaSessionCode={scaSessionCode}
        onReady={onReady}
        onVerificationSucceed={onVerificationSucceed}
        onVerificationFailed={onVerificationFailed}
        onError={onError}
        onCancel={(e) => {
          onCancel?.(e);
          setOpen?.(false);
        }}
      />
    </GeneralModal>
  );
}
